<script>
    import Button from "./Button.svelte";
    import Icon from "./IconSlot.svelte";
    import { LOCALIZATION } from "./routes";
    import KeyMapping from "./KeyMapping.svelte";
    const CONTROLS = "KEY_MAPPING";
    const EXTRAS = "EXTRAS";
    import PlayerConfig from "./PlayerConfig.svelte";
    import IconLink from "./IconLink.svelte";
    const PLAYER_CONFIG = "PLAYER_CONFIG";
    export let setRoute;
    const ACCESSIBILITY_OUTLINE_STORAGE_KEY = "accessibilityOutline";
    const convertToHex = (cssColor) => parseInt(cssColor.slice(1), 16);
    function hexToString(hex) {
        let unPadded = hex.toString(16);
        const length = unPadded.length;
        for (let i = 0; i < 6 - length; i++) {
            unPadded = "0" + unPadded;
        }
        return `#${unPadded}`;
    }

    const AUDIO = "AUDIO";
    const VIDEO = "VIDEO";
    const ACCESSIBILITY = "ACCESSIBILITY";
    let optionsRoute = AUDIO;
    function setOptionsRoute(_optionsRoute) {
        optionsRoute = _optionsRoute;
    }
    function changeVolume(ev) {
        window.changeVolume(ev.target.value / 100);
    }
    function changeVolumeMusic(ev) {
        window.changeVolumeMusic(ev.target.value / 100);
    }
    function changeVolumeGame(ev) {
        window.changeVolumeGame(ev.target.value / 100);
    }
    let cinematicCameraEnabled = globalThis.cinematicCameraEnabled;
    function setCinematicCamera(ev) {
        globalThis.setCinematicCameraEnabled(ev.target.checked);
        cinematicCameraEnabled = globalThis.cinematicCameraEnabled;
    }
    let UIEasyOnTheEyes = globalThis.UIEasyOnTheEyes;
    function setUIEasyOnTheEyes(ev) {
        globalThis.UIEasyOnTheEyes = ev.target.checked;
        UIEasyOnTheEyes = globalThis.UIEasyOnTheEyes;
        globalThis.setOption("UIEasyOnTheEyes", globalThis.UIEasyOnTheEyes);
        Jprompt({
            text: "Changes will take effect after the game is restarted.",
            yesText: "Okay",
            forceShow: true,
        });
    }
    let limitParticleEmitters = globalThis.limitParticleEmitters;
    function setlimitParticleEmitters(number) {
        // -1 means no limit, any other number is the max of particle emitters allowed
        globalThis.limitParticleEmitters = number;
        limitParticleEmitters = globalThis.limitParticleEmitters;
        globalThis.setOption(
            "limitParticleEmitters",
            globalThis.limitParticleEmitters,
        );
    }
    let storedZoom = NaN;
    if (globalThis.STORAGE_ID_UI_ZOOM) {
        storedZoom = parseFloat(
            globalThis.storageGet(globalThis.STORAGE_ID_UI_ZOOM),
        );
    } else {
        console.error("globalThis.STORAGE_ID_UI_ZOOM is undefined");
    }
    let zoomAmount = isNaN(storedZoom) ? 1 : storedZoom;
    let forceRerender = 0;
    function enableDefaultOutlines() {
        globalThis.accessibilityOutline = {
            // Ally
            [0]: {
                targeted: { color: 0x0000ff, thickness: 1 },
                outOfRange: { color: 0xaaaaaa, thickness: 1 },
                regular: { color: 0x000000, thickness: 1 },
            },
            // Enemy
            [1]: {
                targeted: { color: 0xff0000, thickness: 2 },
                outOfRange: { color: 0xaaaaaa, thickness: 2 },
                regular: { color: 0x000000, thickness: 2 },
            },
        };

        // Take immediate effect
        if (typeof devUnderworld !== "undefined")
            devUnderworld.updateAccessibilityOutlines();
        globalThis.storageSet(
            ACCESSIBILITY_OUTLINE_STORAGE_KEY,
            JSON.stringify(globalThis.accessibilityOutline),
        );
        forceRerender += 1;
    }
</script>

{#key forceRerender}
    <div class="flex">
        <aside>
            <div class="flex flex-direction-column gap-15 pad-20">
                <div class="flex align-items-center gap-20">
                    <Button
                        on:click={() => window.goBack()}
                        type="button"
                        text="🠔 Back"
                        class="sm"
                    />
                    <h1 class="aside-title">{globalThis.i18n("Settings")}</h1>
                </div>
                <div class="flex flex-direction-column gap-15">
                    <Button
                        on:click={() => setOptionsRoute(AUDIO)}
                        isActive={optionsRoute == AUDIO}
                        type="button"
                        text={`🔊 ${globalThis.i18n("Audio")}`}
                        style="text-align:left"
                        doLocalizeText={false}
                    />
                    <Button
                        on:click={() => setOptionsRoute(VIDEO)}
                        isActive={optionsRoute == VIDEO}
                        type="button"
                        text={`🖥️ ${globalThis.i18n("Video")}`}
                        style="text-align:left"
                        doLocalizeText={false}
                    />
                    <Button
                        on:click={() => setOptionsRoute(PLAYER_CONFIG)}
                        isActive={optionsRoute == PLAYER_CONFIG}
                        type="button"
                        text={`🧙 ${globalThis.i18n("Player")}`}
                        style="text-align:left"
                        doLocalizeText={false}
                    />
                    <Button
                        on:click={() => setOptionsRoute(CONTROLS)}
                        isActive={optionsRoute == CONTROLS}
                        type="button"
                        text={`⌨️ ${globalThis.i18n("Controls")}`}
                        style="text-align:left"
                        doLocalizeText={false}
                    />
                    {#if globalThis.skipTutorial && globalThis.isTutorialComplete !== undefined && !globalThis.isTutorialComplete()}
                        <Button
                            on:click={() => {
                                globalThis.skipTutorial();
                            }}
                            text="Skip Tutorial"
                            style="text-align:left"
                        />
                    {/if}
                    <Button
                        on:click={() => globalThis.resetTutorial()}
                        type="button"
                        text={`❓ ${globalThis.i18n("Reset Tutorial")}`}
                        style="text-align:left"
                        doLocalizeText={false}
                    />
                    <Icon
                        on:click={() => {
                            setRoute(LOCALIZATION);
                        }}
                        class="button-wrapper-bg-2"
                        align="left"
                    >
                        <img
                            src="ui/localizationIcon.png"
                            alt="language options"
                            width="24"
                            height="24"
                            style="transform: scale(1.4);"
                        />
                        &nbsp; &nbsp;
                        {globalThis.i18n("Language")}
                    </Icon>
                    <Button
                        on:click={() => setOptionsRoute(ACCESSIBILITY)}
                        isActive={optionsRoute == ACCESSIBILITY}
                        type="button"
                        text={`🌐 ${globalThis.i18n("Accessibility")}`}
                        style="text-align:left;"
                        doLocalizeText={false}
                    />
                </div>
            </div>
            <button
                id="devSettings"
                on:click={() => setOptionsRoute(EXTRAS)}
                isActive={optionsRoute == EXTRAS}
                type="button">Developer Settings</button
            >
        </aside>

        <main>
            <div class="pad-20">
                {#if optionsRoute == ACCESSIBILITY}
                    <div class="flex flex-direction-column gap-15">
                        <label>
                            <input
                                type="checkbox"
                                bind:checked={UIEasyOnTheEyes}
                                on:click={setUIEasyOnTheEyes}
                            />
                            {globalThis.i18n(
                                "Enable less bright background colors",
                            )}
                        </label>
                        <hr />
                        <label for="fontSelector">Font</label>
                        <select
                            id="fontSelector"
                            style="width:200px"
                            on:change={(e) => {
                                globalThis.setFontOverride(e.target.value);
                            }}
                        >
                            <option value=""></option>
                            <option value="forum">Default</option>
                            <option value="arial">Arial</option>
                        </select>
                        <hr />
                        <h2>
                            {globalThis.i18n("Blood and  Gore")}
                        </h2>
                        <div
                            class="flex flex-direction-column gap-15"
                            style="max-width:200px;"
                        >
                            <Button
                                on:click={() => {
                                    globalThis.setOption("noGore", true);
                                    globalThis.noGore = true;
                                    forceRerender += 1;
                                }}
                                isActive={globalThis.noGore}
                                text="Off"
                            />
                            <Button
                                on:click={() => {
                                    globalThis.setOption("noGore", false);
                                    globalThis.noGore = false;
                                    forceRerender += 1;
                                }}
                                isActive={!globalThis.noGore}
                                text="Normal"
                            />
                        </div>
                        <h1>Unit Outlines</h1>
                        <button
                            style="width:200px"
                            on:click={enableDefaultOutlines}
                            >{globalThis.i18n("Default unit outlines")}</button
                        >
                        {#each [0, 1] as faction}
                            <h2>
                                {globalThis.i18n(["Ally", "Enemy"][faction])} Outlines
                            </h2>
                            <div class="flex gap-15">
                                {#each ["regular", "targeted", "outOfRange"] as type}
                                    <div
                                        class="flex flex-direction-column border-chooser"
                                    >
                                        <h4>{globalThis.i18n(type)}</h4>
                                        <div class="flex flex-gap-15">
                                            <label>
                                                <div>
                                                    {globalThis.i18n(
                                                        "outline thickness",
                                                    )}
                                                </div>
                                                <!-- svelte-ignore missing-declaration -->
                                                <input
                                                    type="range"
                                                    min="0"
                                                    max="5"
                                                    value={globalThis
                                                        .accessibilityOutline[
                                                        faction
                                                    ][type].thickness}
                                                    on:input={(e) => {
                                                        globalThis.accessibilityOutline[
                                                            faction
                                                        ][type].thickness =
                                                            parseInt(
                                                                e.target.value,
                                                            );
                                                        // Take immediate effect
                                                        if (
                                                            typeof devUnderworld !==
                                                            "undefined"
                                                        )
                                                            devUnderworld.updateAccessibilityOutlines();
                                                        globalThis.storageSet(
                                                            ACCESSIBILITY_OUTLINE_STORAGE_KEY,
                                                            JSON.stringify(
                                                                globalThis.accessibilityOutline,
                                                            ),
                                                        );
                                                    }}
                                                />
                                            </label>
                                            <label>
                                                <div>
                                                    {globalThis.i18n("color")}
                                                </div>
                                                <!-- svelte-ignore missing-declaration -->
                                                <input
                                                    type="color"
                                                    value={hexToString(
                                                        globalThis
                                                            .accessibilityOutline[
                                                            faction
                                                        ][type].color,
                                                    )}
                                                    on:input={(e) => {
                                                        globalThis.accessibilityOutline[
                                                            faction
                                                        ][type].color =
                                                            convertToHex(
                                                                e.target.value,
                                                            );
                                                        // Take immediate effect
                                                        if (
                                                            typeof devUnderworld !==
                                                            "undefined"
                                                        )
                                                            devUnderworld.updateAccessibilityOutlines();
                                                        globalThis.storageSet(
                                                            ACCESSIBILITY_OUTLINE_STORAGE_KEY,
                                                            JSON.stringify(
                                                                globalThis.accessibilityOutline,
                                                            ),
                                                        );
                                                    }}
                                                />
                                            </label>
                                        </div>
                                    </div>
                                {/each}
                            </div>
                        {/each}
                        <hr />
                        <div>
                            {globalThis.i18n(
                                "report missing accessibility features",
                            )}
                            <div
                                style="max-width:124px;display:block;margin: 8px auto;"
                            >
                                <IconLink
                                    src="ui/discord_logo.png"
                                    alt="Spellmasons Discord https://discord.gg/q6sUCreHeJ"
                                    width="24px"
                                    href="https://discord.gg/q6sUCreHeJ"
                                    class="button-wrapper-bg-2"
                                    text="Discord"
                                />
                            </div>
                        </div>
                    </div>
                {:else if optionsRoute == AUDIO}
                    <div class="flex flex-direction-column gap-15">
                        {globalThis.i18n("Total Volume")}
                        <input
                            type="range"
                            value={window.volume * 100}
                            on:input={changeVolume}
                            min="0"
                            max="100"
                        />
                        {globalThis.i18n("Music Volume")}
                        <input
                            type="range"
                            value={window.volumeMusic * 100}
                            on:input={changeVolumeMusic}
                            min="0"
                            max="100"
                        />
                        {globalThis.i18n("Sound Effects Volume")}
                        <input
                            type="range"
                            value={window.volumeGame * 100}
                            on:input={changeVolumeGame}
                            min="0"
                            max="100"
                        />
                        <Button
                            on:click={() => window.playNextSong()}
                            text="Play next song"
                        />
                    </div>
                {:else if optionsRoute == VIDEO}
                    <div class="flex flex-direction-column gap-15">
                        <Button
                            on:click={() => {
                                if (globalThis.isElectron) {
                                    globalThis.electronSettings.setFullscreen(
                                        true,
                                    );
                                } else {
                                    document.body
                                        .requestFullscreen()
                                        .catch((err) => {
                                            console.error(
                                                `Error attempting to enable fullscreen mode: ${err.message} (${err.name})`,
                                            );
                                        });
                                }
                            }}
                            text="Set Fullscreen"
                        />
                        <Button
                            on:click={() => {
                                if (globalThis.isElectron) {
                                    globalThis.electronSettings.setFullscreen(
                                        false,
                                    );
                                } else {
                                    document.exitFullscreen();
                                }
                            }}
                            text="Set Windowed Mode"
                        />
                        <label>
                            <input
                                type="checkbox"
                                bind:checked={cinematicCameraEnabled}
                                on:click={setCinematicCamera}
                            />
                            {globalThis.i18n("Enable Cinematic Camera")}
                        </label>
                        <h2>
                            {globalThis.i18n("Performance")}
                        </h2>
                        <div class="flex flex-direction-column gap-15">
                            {globalThis.i18n("Particle Emitters")}
                            <Button
                                on:click={() => {
                                    setlimitParticleEmitters(0);
                                    forceRerender += 1;
                                }}
                                isActive={globalThis.limitParticleEmitters == 0}
                                text="Off"
                            />
                            <Button
                                on:click={() => {
                                    setlimitParticleEmitters(5);
                                    forceRerender += 1;
                                }}
                                isActive={globalThis.limitParticleEmitters == 5}
                                text="Low"
                            />
                            <Button
                                on:click={() => {
                                    setlimitParticleEmitters(-1);
                                    forceRerender += 1;
                                }}
                                isActive={globalThis.limitParticleEmitters ==
                                    -1}
                                text="On"
                            />
                        </div>
                        <h2>
                            {globalThis.i18n("Blood and  Gore")}
                        </h2>
                        <div class="flex flex-direction-column gap-15">
                            <Button
                                on:click={() => {
                                    globalThis.setOption("noGore", true);
                                    globalThis.noGore = true;
                                    forceRerender += 1;
                                }}
                                isActive={globalThis.noGore}
                                text="Off"
                            />
                            <Button
                                on:click={() => {
                                    globalThis.setOption("noGore", false);
                                    globalThis.noGore = false;
                                    forceRerender += 1;
                                }}
                                isActive={!globalThis.noGore}
                                text="Normal"
                            />
                        </div>
                        {#if globalThis.isElectron}
                            {globalThis.i18n("UI Scale")}: {zoomAmount}
                            <div class="flex gap-15">
                                <Button
                                    on:click={() => {
                                        zoomAmount -= 0.1;
                                        // Math.max to prevent it from going below 0.1
                                        // Round to 1 decimal point to protect against floating point errors
                                        zoomAmount = Math.max(
                                            0.1,
                                            Math.round(zoomAmount * 10) / 10,
                                        );
                                        globalThis.storageSet(
                                            globalThis.STORAGE_ID_UI_ZOOM,
                                            zoomAmount,
                                        );
                                        globalThis.electronSettings.setUIZoom(
                                            zoomAmount,
                                        );
                                    }}
                                    text="Smaller"
                                />
                                <Button
                                    on:click={() => {
                                        zoomAmount += 0.1;
                                        // Round to 1 decimal point to protect against floating point errors
                                        zoomAmount =
                                            Math.round(zoomAmount * 10) / 10;
                                        globalThis.storageSet(
                                            globalThis.STORAGE_ID_UI_ZOOM,
                                            zoomAmount,
                                        );
                                        globalThis.electronSettings.setUIZoom(
                                            zoomAmount,
                                        );
                                    }}
                                    text="Bigger"
                                />
                            </div>
                        {/if}
                    </div>
                {:else if optionsRoute == PLAYER_CONFIG}
                    <PlayerConfig />
                {:else if optionsRoute == CONTROLS}
                    <KeyMapping />
                {:else if optionsRoute == EXTRAS}
                    <div class="flex flex-direction-column gap-15">
                        <Button
                            on:click={() => {
                                window.monitorFPS();
                            }}
                            text="Toggle FPS / Latency Monitor"
                        />
                        <Button
                            on:click={() => {
                                window.electronSettings.toggleDevTools();
                            }}
                            text="Toggle Console"
                        />
                    </div>
                {/if}
            </div>
        </main>
    </div>
{/key}

<style>
    .border-chooser {
        padding: 15px;
        border: 1px solid #454545;
    }
    #devSettings {
        position: absolute;
        bottom: 28px;
        left: 28px;
        background: none;
        border: none;
        padding: 0;
        font: inherit;
        cursor: pointer;
        color: #262626;
        outline: inherit;
    }
    aside {
        border-right: 2px solid #efefef;
        width: 300px;
        /* Ensure that the options aside will become scrollable if the screen is too small */
        overflow-y: auto;
        /* Ensure it doesn't overlap with the border around the edges of the window */
        max-height: 90vh;
    }
    hr {
        width: 100%;
    }
    h1,
    h2,
    h4 {
        margin: 0;
    }
</style>
